<template>
<div class="xhead">
  <div class="header_left">
    <a href="/">
      <img src="@/assets/logo.png" />
      <span>
        <h4>新县全域旅游</h4>
        <h5>NEW COUNTRY TOURISM</h5>
      </span>
    </a>
  </div>
  <div class="header_right">
    <div class="xmenu">
      <el-menu :router="true" :default-active="activeMenu" class="el-menu-demo" mode="horizontal">
        <el-menu-item index="/"><i class="el-icon-s-home"></i><span>网站首页</span></el-menu-item>
        <el-menu-item index="/searchLT"><i class="el-icon-s-order"></i><span>探索新县</span></el-menu-item>
        <el-menu-item index="/playLT"><i class="el-icon-star-on"></i><span>玩在新县</span></el-menu-item>
        <el-menu-item index="/localCustoms"><i class="el-icon-menu"></i><span>乡土民情</span></el-menu-item>
      </el-menu>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data(){
    return {
    }
  },
  computed:{
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      return path
    },
  },
  components: {
  },
  methods:{
   
  },
  mounted() {
    
  },
}
</script>

<style scoped>

</style>
